/* eslint-disable no-negated-condition */
import { derived, writable } from "svelte/store";
import {
  browser,
  supportsEnhancedExperience,
  supportsVoice
} from "@utils/support";
import { EXPERIENCE_TYPES, VIDEOS } from "../consts";

// Which video component is currently active and on top
export const activeVideo = writable(
  supportsEnhancedExperience ? VIDEOS.DWELL : VIDEOS.CONVERSATION
);

// Reference to conversation <video> element
export const conversationVideo = writable(null);

// Reference to dwell <video> element
export const dwellVideo = writable(null);

export const displayTooltip = writable(true);

export const experience = writable();

export const experienceType = writable(
  supportsVoice ? EXPERIENCE_TYPES.VOICE : EXPERIENCE_TYPES.TEXT
);

// Has intro video been played already?
export const introSeen = writable(false);

// Are we interacting with an experience?
export const maximized = writable(false);

// Is mic permission granted?
export const microphoneAvailable = writable(false);

// Response from nlu
export const response = writable();

export const textMode = derived(
  experienceType,
  ($type) => $type === EXPERIENCE_TYPES.TEXT
);

// Parent viewport height & width
export const viewport = writable(
  browser
    ? {
        height: Math.max(
          document.documentElement.clientHeight || 0,
          window.innerHeight || 0
        ),
        width: Math.max(
          document.documentElement.clientWidth || 0,
          window.innerWidth || 0
        )
      }
    : {}
);

export const voiceMode = derived(
  experienceType,
  ($type) => $type === EXPERIENCE_TYPES.VOICE
);
